document.addEventListener('DOMContentLoaded', function() {
  /// popup contact form
  let openFormButtons = document.querySelectorAll('a[href="#contact-team"]');
  const popupFormBlock = document.querySelector('.popup-contact-form');
  const popupFormClose = document.querySelector('.popup-contact-form__close');

  popupFormClose.addEventListener('click', function() {
    popupFormBlock.classList.remove('active');

    if (location.hash.includes('__popup-contact-form')) {
      let myNewURL = removeUrlSearch();

      window.history.pushState("new state", "State", "/" + myNewURL);
    }
  });

  openFormButtons.forEach(function(item) {
    item.addEventListener('click', function(event) {
      event.preventDefault();
      popupFormBlock.classList.add('active');
    })
  })

  if (location.hash.includes('__popup-contact-form')) {
    popupFormBlock.classList.add('active');
  }

  function removeUrlSearch() {
    let currURL = window.location.href;
    let afterDomain = currURL.substring(currURL.lastIndexOf('/') + 1);
    let beforeQueryString = afterDomain.split("?")[0];

    return beforeQueryString;
  }

  // redirect to product review
  document.querySelectorAll('.grid-product .jdgm-preview-badge').forEach(function(productReview) {
    productReview.addEventListener('click', function() {
      let productLink = this.closest('.grid-product__link').href;
      productLink += '#judgeme_product_reviews';

      window.location.href = productLink;
    })
  })

  // single/multiple order
  if (document.querySelector('.single-multiple-order')) {
    let isMultipleOrder = false;
    const orderTypeSwitcher = document.querySelectorAll('.single-multiple-order__radio[name="order-type-switcher"]');
    const multipleForm = document.querySelector('.single-multiple-order__body');
    const multipleAddToCartButton = document.querySelector('.add-to-cart-multiple');

    orderTypeSwitcher.forEach(function(item) {
      item.addEventListener('change', function() {
        if (this.checked && this.value === 'Multiple') {
          isMultipleOrder = true;
        } else {
          isMultipleOrder = false;
        }

        changeOrderType(isMultipleOrder)
      })
    })

    function changeOrderType(isMultipleOrder) {
      if (isMultipleOrder) {
        document.querySelector('.variant-wrapper').closest('.product-block').style.display = 'none';
        document.querySelector('.product__quantity').style.display = 'none';
        document.querySelector('.shopify-payment-button').style.display = 'none';
        document.querySelector('.add-to-cart[data-add-to-cart]').style.display = 'none';
        multipleForm.classList.add('active');
        multipleAddToCartButton.classList.add('active');
      } else {
        document.querySelector('.variant-wrapper').closest('.product-block').style.display = 'block';
        document.querySelector('.product__quantity').style.display = 'block';
        document.querySelector('.shopify-payment-button').style.display = 'block';
        document.querySelector('.add-to-cart[data-add-to-cart]').style.display = 'block';
        multipleForm.classList.remove('active');
        multipleAddToCartButton.classList.remove('active');
      }
    }

    multipleAddToCartButton.addEventListener('click', function(event) {
      event.preventDefault();
      let orderList = [];

      multipleForm.querySelectorAll('.single-multiple-order__variant').forEach(function(item) {
        let itemQuaintity = item.querySelector('.js-qty__num').value;
        let itemId = item.dataset.variationId;
        let itemColor = item.dataset.color;

        if (itemQuaintity > 0) {
          // orderList.push({ id: itemId, quantity: itemQuaintity, properties: {Color: itemColor} })
          orderList.push({
            id: itemId,
            quantity: itemQuaintity
          })
        }
      });

      if (orderList.length > 0) {
        this.classList.add('btn--loading');
        multipleAddToCart(orderList);
      }
    });

    function multipleAddToCart(items) {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: items
        })
      })
        .then(response => response.json())
        .then(data => {
          const cartDrawer = new window.theme.CartDrawer();

          cartDrawer.open();

          multipleAddToCartButton.classList.remove('btn--loading');
        })
        .catch(error => {
          console.error('Error adding variants to cart:', error);
        });
    }
  }

  // group cart drawer products

  function groupCartDrawerProducts() {
    let cartItems = document.querySelectorAll('#CartDrawer .cart__item');
    let itemsProductId = [];

    if (cartItems.length > 0) {
      cartItems.forEach(function(item) {
        itemsProductId.push(item.dataset.productId);
      });

      let uniqueProducts = [...new Set(itemsProductId)];

      let groupedProducts = [];

      cartItems.forEach(function(item) {
        let size = item.querySelector('.cart__variant-value[data-name="Size"]').innerText;
        let variantId = item.dataset.variantId;
        let quantity = item.querySelector('.js-qty__num').value;
        if (groupedProducts[item.dataset.productId] === undefined) {
          groupedProducts[item.dataset.productId] = {
            sizes: [],
            variants_id: []
          };
          groupedProducts[item.dataset.productId]['sizes'].push(size + '(' + quantity + ')');
          groupedProducts[item.dataset.productId]['variants_id'].push(variantId);
        } else {
          groupedProducts[item.dataset.productId]['sizes'].push(size + '(' + quantity + ')');
          groupedProducts[item.dataset.productId]['variants_id'].push(variantId);
        }
      });

      for (let productId in groupedProducts) {
        let joined = groupedProducts[productId]['sizes'].join(', ');
        groupedProducts[productId]['sizes'] = joined;
      }

      cartItems.forEach(function(item) {
        let productId = item.dataset.productId;

        if (uniqueProducts.includes(productId)) {
          item.querySelector('.cart__variant-value[data-name="Size"]').innerText = groupedProducts[productId]['sizes'];
          uniqueProducts = uniqueProducts.filter(function(uniqueItem) {
            if (uniqueItem !== productId) {
              return uniqueItem;
            }
          })

          item.querySelector('.cart__item--qty').remove();
          item.querySelector('.cart__item--price').remove();

          const deleteButton = document.createElement('div');

          deleteButton.setAttribute('aria-label', 'Remove product');
          deleteButton.classList.add('cart__item--remove');
          deleteButton.innerHTML = '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 64 64"><title>icon-X</title><path d="m19 17.61 27.12 27.13m0-27.12L19 44.74"></path></svg>';

          item.querySelector('.cart__item--details').append(deleteButton);

          deleteButton.addEventListener('click', function() {
            deleteCartDrawerItems(groupedProducts[productId]['variants_id']);
          })
        } else {
          item.remove();
        }
      });
    }
  }

  const cartDrawer = document.getElementById('CartDrawer');

  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {

        if (cartDrawer.classList.contains('drawer--is-open')) {
          groupCartDrawerProducts();
        } else {

        }
      }
    }
  });

  observer.observe(cartDrawer, {
    attributes: true
  });

  /// delete cart item
  if (document.querySelector('.cart__item--delete')) {
    const cartItemsBtnDelete = document.querySelectorAll('.cart__item--delete');

    cartItemsBtnDelete.forEach(function(item) {
      item.addEventListener('click', function() {
        const cartItem = this.closest('.cart__item');

        deleteCartItem(cartItem);
      })
    })
  }

  function deleteCartDrawerItems(variants_id) {
    let data = {
      'updates': {}
    };

    variants_id.forEach(function(item) {
      data['updates'][item] = 0;
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
      .then(response => response.json())
      .then(data => {
        location.reload();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  function deleteCartItem(cartItem) {
    const itemId = cartItem.dataset.key;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: itemId,
        quantity: 0
      })
    })
      .then(response => response.json())
      .then(data => {
        location.reload();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
});
